import styled from "styled-components";
import theme, { Breakpoints } from "themes/simple-theme-vh";

interface IProps {
  noBackground?: boolean;
  isLastNum?: boolean;
  isEnter?: boolean;
}

const NumKey = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ noBackground }: IProps) =>
    `
    color: ${theme.color.primary};
    font-family: ${theme.fontFamily.black};
    font-size: ${theme.fontSize.headings.h2};
    border-radius: ${theme.global.radius};
    background: ${noBackground ? "transparent" : theme.color.white};
    ${noBackground && `grid-column: 2/4;`}
    `};

  ${({ isEnter }: IProps) =>
    isEnter &&
    `
    grid-column: 2/4;
    background-color: ${theme.color.primary};
  `};
`;

export default NumKey;



// WEBPACK FOOTER //
// ./src/components/common/NumPad/NumKey.tsx